import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import Constants from "expo-constants";

// Optionally import the services that you want to use
// import {...} from "firebase/auth";
// import {...} from "firebase/database";
// import {...} from "firebase/firestore";
// import {...} from "firebase/functions";
// import {...} from "firebase/storage";

// Initialize Firebase
const firebaseConfig = {
  apiKey: Constants.manifest?.extra?.firebaseApiKey,
  authDomain: "matumaatika.firebaseapp.com",
  projectId: "matumaatika",
  storageBucket: "matumaatika.appspot.com",
  messagingSenderId: "32880048855",
  appId: "1:32880048855:web:1c20feb2cac16253fc4e92",
  measurementId: "G-0SHHTSG9J1",
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

// For more information on how to access Firebase in your project,
// see the Firebase documentation: https://firebase.google.com/docs/web/setup#access-firebase
